<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>Return to the previous page and make the selection manifest again!</p>
        <a-button type="primary" block>
          <router-link to="/supplierEvaluationPurchasing">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{span:24}" :lg="{span:16}">
          <a-card :loading="loading">
            <div slot="title">Manifest Evaluation Supplier
              <small class="m-display-block m-text-small">{{
                data.suplier.no_trans
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">
                <span slot="title">Select Action</span>
              </span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    block
                    icon="printer"
                    class="m-display-block"
                    :loading="printLoad.manifest"
                  >Manifest</a-button>
                </li>
                <li v-if="getAuth.username == data.suplier.user_pembuat">
                  <a-button-group>
                  <a-button
                    :disabled="
                      !(
                        data.last_status == 'Revised' &&
                        getAuth.username == data.suplier.user_pembuat
                      )
                    "
                    @click="handleEdit"
                    type="dashed"
                    size="small"
                    icon="edit"
                    block
                    class="m-display-block"
                    >Edit</a-button
                  >
                  <a-button
                  :disabled="
                      !(
                        data.last_status == 'Revised' &&
                        getAuth.username == data.suplier.user_pembuat
                      )
                    "
                  @click="handlecanceltrans"
                  type="danger"
                  size="small"
                  icon="close-square"
                  :loading="printLoad.cancel"
                  >Cancel</a-button
                >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Supplier Name</span>
                  <span class="m-list-desc">{{data.suplier.supplier_name}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Address</span>
                  <span class="m-list-desc">{{data.suplier.addres}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No. Account Bank</span>
                  <span class="m-list-desc">{{data.suplier.no_account_bank}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank</span>
                  <span class="m-list-desc">{{data.suplier.bank}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Contact Person</span>
                  <span class="m-list-desc">{{data.suplier.contact_person}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type of product</span>
                  <span class="m-list-desc">{{data.suplier.type_of_product}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{data.suplier.category}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Evaluation Note</span>
                  <span class="m-list-desc">{{data.suplier.catatan ? data.suplier.catatan
                    : "-"}}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card class="margin-top" :loading="loading">
            <div slot="title">Supplier Evaluation</div>
            <div slot="extra">
              <a-tag>{{data.suplier.kriteria}}</a-tag>
            </div>
            <div>
              <ul class="m-list-wrapper bordered">
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Price</span>
                    <span class="m-list-desc">{{data.suplier.price_point}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.price_desc}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Quality</span>
                    <span class="m-list-desc">{{data.suplier.quality_point}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.quality_desc}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Service</span>
                    <span class="m-list-desc">{{data.suplier.service_point}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.service_desc}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Risk Analysis</span>
                    <span class="m-list-desc">{{data.suplier.risk_analysis_point}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.risk_analysis_desc}}</span>
                </li>
              </ul>
            </div>
            <template slot="actions">
              <div class="m-text-align right">
                <h4 class="m-list-desc margin-remove">Total Ratings</h4>
                <h2 class="m-list-desc margin-remove">{{data.suplier.total_ratings}} Point</h2>
              </div>
            </template>
          </a-card>
          <a-card class="margin-top" :loading="loading" v-if="data.jenis !== 'manifest'">
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Save</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{span:24}" :lg="{span:8}">
          <a-collapse class="margin-remove" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Transaction Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{data.suplier.user_pembuat}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{moment(data.suplier.tanggal_buat).format(this.getDateTimeFormat)}}</h4>
                    <span
                      class="m-text-small"
                      v-if="data.suplier.catatan === null || data.suplier.catatan === '' "
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{data.suplier.catatan}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{moment(workflow.tanggal_aksi).format('DD-MM-YYYY HH:mm:ss')}}</h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark === null || workflow.remark === '' "
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{workflow.remark}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <!-- <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Supporting documents</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.dokumen_pendukung">
                <Empty
                  v-if="data.dokumen_pendukung ? data.dokumen_pendukung.length<=0 : data.dokumen_pendukung"
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 class="m-list-dots margin-removes">{{item.nama_document}}</h4>
                      <a-button
                        size="small"
                        type="default"
                        icon="cloud-download"
                        @click="handleDownload(item.url)"
                      ></a-button>
                    </div>
                    <p
                      slot="description"
                      :class="getScreen ? 'm-list-dots' : ''"
                    >{{item.fungsi_document}}</p>
                    <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" />
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse> -->

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.dokumen_terkait">
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 class="margin-remove">{{item.tipe.toUpperCase()}} | {{item.tlc_pembuat}}</h4>
                      <div>
                        <Status :status="item.status" />
                        <a-button @click="handleView(item)" size="small" type="default" icon="eye"></a-button>
                      </div>
                    </div>
                    <div slot="description">
                      <span>{{item.no_manifest}}</span>
                      <span class="m-display-block">{{moment(item.tgl_buat).format('DD-MM-YYYY')}}</span>
                      <p c v-if="item.deskripsi !== null">{{item.deskripsi}}</p>
                      <p v-else>Tidak Ada Catatan</p>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;History Status
      </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="margin-remove m-list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import Axios from "axios";
import moment from "moment";
import HandleRoute from "@/mixins/HandleRoute";

export default {
  name: "PurchasingManifest",
  props: ["id", "user_pembuat"],
  components: { "m-anim": lottie, Status },
  mixins: [HandleRoute],
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getIsSpecialMenu","getDateTimeFormat"]),
    menutype(){
      // let key = localStorage.getItem("nvky");
      // if (key==47){
      //   return 'Purchasing';
      // }else if(key==73){
      //   return 'GA';
      // }else if(key==145){
      //   return 'Fin';
      // }else{
      //   return '';
      // }
      let res = ""
      this.getAuth.nama_bidang.forEach(element => {
        if(element == 'Financial Control'){
          res = 'Fin';
        }else if( element == 'Purchasing'){
          res = 'Purchasing';
        }else if( element == 'General Affair Supervisor'){
          res = 'GA';
        }
      });
      return res
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loading: true,
      printLoad: {
        manifest: false,
        cancel: false,
      },
      notfound: { animationData: notfound, loop: true },
      id_supplier: this.id,
      data: {
        status_app: [],
        suplier: [],
        dokumen_terkait: [],
        dokumen_pendukung: [],
        jenis: "",
        last_status: "",
        notifikasi: [],
        aksi: [],
      },
      visibleHistory: false,
    };
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
    this.fetchManifest(this.id);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest(this.id);
      }
    },
  },
  methods: {
    moment,
    fetchManifest(value) {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "evaluasi_suplier",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_evaluasi: value,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data.status_app = response.data.status_app[0];
          this.data.suplier = response.data.suplier[0];
          this.data.dokumen_terkait = response.data.dokumen_terkait;
          this.data.dokumen_pendukung = response.data.dokumen_pendukung;
          this.data.jenis = response.data.jenis;
          this.data.status_app = response.data.status_app;
          this.data.last_status = response.data.last_status;
          this.data.notifikasi = response.data.notifikasi;
          this.data.aksi = response.data.aksi;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle() {
      this.visibleHistory = !this.visibleHistory;
    },

    handleDownload(item) {
      window.open(this.$serviceUrl + item, "_blank");
    },

    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        Axios({
          method: "post",
          url: this.$serviceUrl + "evaluasi_suplier/approval ",
          processData: false,
          data: {
            id_manifest: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.displayMessage("success");
            this.$router.push({
            name: (this.menutype=='Purchasing' ? "supplierEvaluationPurchasing" : 
            (this.menutype=='Fin' ? "supplierEvaluationFin" : "supplierEvaluationGA")),
            params: { id: this.id },
          });
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "evaluasi_suplier/cetak",
        responseType: "blob",
        params: {
          id_eval_supplier: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "supplierEvaluation-edit"+this.menutype,
        params: { id: this.id, type:"revised" },
      });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      Axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        responseType: "blob",
        data: {
          jenis_trans: "evaluasi_suplier",
          id_manifest: this.id,
          tlc: this.getAuth.username,
          code_trans: this.data.suplier.no_trans,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go(0);
        })
        .catch((err) => {
          this.printLoad.cancel = false;
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.push({ name: "beranda" });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>